<template>
    <span :class="{ 'truncate': truncate }">
        <template v-if="column === 'number'">
            {{ index + 1 }}
        </template>
        <template v-if="column === 'name'">
            <nio-optional :value="row.name" />
        </template>
        <template v-if="column === 'date'">
            <nio-optional :value="row.date" />
        </template>
        <template v-if="column === 'phone'">
            <nio-optional :value="row.phone" />
        </template>
        <template v-if="column === 'email'">
            <nio-optional :value="row.email" />
        </template>
        <template v-if="column === 'appointmentNotes'">
            <nio-optional :value="row.appointmentNotes" />
        </template>
        <template v-if="column === 'contactNotes'">
            <nio-optional :value="row.contactNotes" />
        </template>
        <template v-if="column === 'communicationPreference'">
            <nio-optional :value="row.communicationPreference" />
        </template>
        <template v-if="columnIsPlaceholder">
            <nio-optional :value="row[placeholderName]" />
        </template>
        <template v-if="column === 'status'">
            <nio-badge
                color="green"
                v-if="isSuccess"
            >
                {{ $t('global.general.success') }}
            </nio-badge>
            <nio-badge
                color="yellow"
                v-tooltip="$t('imports.preview.missingOptionalData')"
                v-if="isWarning"
            >
                {{ $t('global.general.warning') }}
            </nio-badge>
            <nio-badge
                color="red"
                v-tooltip="$t('imports.preview.missingRequiredDate')"
                v-if="isError"
            >
                {{ $t('global.general.error') }}
            </nio-badge>
        </template>
    </span>
</template>

<script>
    export default {
        props: {
            column: {
                type: String,
                required: true,
            },
            row: {
                type: Object,
                required: true,
            },
            index: {
                type: Number,
                required: true,
            },
            importType: {
                type: String,
                required: true,
            },
            placeholders: {
                type: Array,
                default: () => [],
            },
            truncate: {
                type: Boolean,
                default: true,
            },
        },

        computed: {
            isWarning() {
                return this.row.invalid == 'name';
            },

            isError() {
                return this.row.invalid == 'phone' ||
                    this.importType == 'appointment' && this.row.invalid == 'date';
            },

            isSuccess() {
                return !this.isError && !this.isWarning;
            },

            columnIsPlaceholder() {
                return this.column.startsWith('placeholder');
            },

            placeholderName() {
                if (!this.columnIsPlaceholder) {
                    return null;
                }

                const index = this.column.replace('placeholder', '');

                return this.placeholders[index].name;
            },
        },
    };
</script>
